<template>
    <b-modal
        v-model="mostrarModalMeta"
        @show="obterTiposInstrumento()"
        @hide="fecharModal()"
        @close="fecharModal()"
        no-enforce-focus>
        <div slot="modal-title">
            Meta -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <b-row>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Tipos de Instrumento</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="tiposInstrumento"
                            text-field="descCategoria"
                            value-field="codCategoria"
                            v-model="codCategoria">
                        </b-form-select>
                        <b-form-invalid-feedback>O Tipo de Instrumento da meta é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Quantidade</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import EventosServicos from '../EventosServicos'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        evento: {
            type: Object,
            default: () => {}
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        codCategoria: {
            required
        },
        quantidade: {
            required,
            minValue: minValue(0.1)
        }
    },

    data() {
        return {
            mostrarModalMeta: false,
            codCategoria: null,
            tiposInstrumento: [],
            quantidade: null,
            operacaoProp: 'INSERÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalMeta = false
            this.quantidade = null
            this.tiposInstrumento = []
            this.codCategoria = null
        },

        obterTiposInstrumento() {
            this.$store.dispatch('addRequest')
            EventosServicos.obterTiposInstrumento().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tiposInstrumento = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar(){
            this.$store.dispatch('addRequest')
            let metaDto = {
                tipoInstrumento : this.codCategoria,
                quantidade: this.quantidade,
                idEvento: this.evento.idEvento
            }
            EventosServicos.inserirMeta(metaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Meta inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalMeta = this.mostrarModal
        },
    },
}
</script>
